// store/modules/sellOrders.js
import axios from '@/axios';

export default {
	namespaced: true,

	state: {
		orders: [],
	},

	mutations: {
		SET_SELL_ORDERS(state, orders) {
			state.orders = orders;
		},
		CLEAR_SELL_ORDERS(state) {
			state.orders = [];
		},
	},

	actions: {
		// Fetch sell-skin orders (offers) history from the server
		fetchSellOrders({ commit }) {
			return axios
				.get(`offer/history`)
				.then((response) => {
					const orders = response.data?.payload || [];
					console.log('response.data?.payload', response.data?.payload);

					commit('SET_SELL_ORDERS', orders);
				})
				.catch((error) => {
					console.error('Error fetching sell orders:', error);
				});
		},
	},

	getters: {
		sellOrders: (state) => state.orders,

		// adjust status value to whatever Offer::STATUS_* actually is (string / int)
		pendingSellOrders: (state) =>
			state.orders.filter((o) => o.status === 'pending'),
	},
};
